export default __webpack_public_path__ + "64ad5ffd1c4dcb347ed38b52a30acad2.png";